import React, { useContext, useState, useEffect } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import './Header.css'
import WalletIcon from '@mui/icons-material/Wallet';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import referralIcon from './../../Assets/Referral-icon.png'
// import ChatIcon from '@mui/icons-material/Chat';
import BearMarketLogo from './../../Assets/Bear_Bull_logo_transparent_dark.png'
import { StockContext } from '../Context/StockContext';
import { Popover, List, ListItem, ListItemText } from '@mui/material';
import HelpIcon from '@mui/icons-material/Help';
// import { useNavigate } from 'react-router-dom'
import axios from 'axios';
import Transactions from '../Alerts/transactions';
import { red } from '@mui/material/colors';

const Header = (props) => {
  const { handlePaymentInfo, paid, user, setAlert_message, setMessage_status, user_referral_code } = useContext(StockContext)

  const [userPayment, setUserPayment] = useState(0)
  const [statement, setStatement] = useState(null)
  const [transaction_alert, setTransaction_alert] = useState(false)

  async function UpdateonSubmit() {
    setAnchorEl(null)
    const enteredAmount = prompt('Enter amount:')
    setUserPayment(Number(enteredAmount))
  }



  const get_transaction_statement = async () => {
    try{
        setStatement(null)
        setAnchorEl(null)
      //   setAnchorEl(null)
        const response = await axios.post("https://8d03jbj0jk.execute-api.ap-south-1.amazonaws.com/Dev/user/statement"
            , {email: user.signInDetails.loginId}
            , {headers: {"Content-Type":'application/json'}}
        )
        // setAlert_message(response.data.alert)
        setStatement(response.data.statement)
    } catch(error) {console.error('There was an error handling the referral code:', error);}
} 

  // console.log(userPayment)
  console.log(statement)

  const toggle_transaction_alert = () => {
    setTransaction_alert(!transaction_alert)
  }

  useEffect(() => { if(statement !== null) {setTransaction_alert(true)} }, [statement])


  useEffect(() => {
    if (userPayment !== 0) {
      handlePaymentInfo(userPayment)
    }
  }, [userPayment])


  const Logout = () => {
    // setUser(null)
    props.signOut()
  }

  // Popover attributes for Wallet:
  //PopOver icon functuanality:
  const [anchorEl, setAnchorEl] = useState(null);

  //Handle click to open/close the Popover - Wallet
  const Wallet_handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget)
  }


  //Handle closing of Popover: Wallet
  const Wallet_handleClose = () => {
    setAnchorEl(null)
  };


  // Popover attributes for Account:
  // New state for this specific Popover
  const [accountAnchorEl, setAccountAnchorEl] = useState(null);

  // Handle click for AccountCircle Popover
  const handleAccountClick = (event) => {
    setAccountAnchorEl(accountAnchorEl ? null : event.currentTarget);
  };

  // Handle close for AccountCircle Popover
  const handleAccountClose = () => {
    setAccountAnchorEl(null);
  };

  // Control open state and id for account specific Popover
  const accountOpen = Boolean(accountAnchorEl);
  const accountId = accountOpen ? 'account-popover' : undefined;

  const open = Boolean(anchorEl); // Boolean state to control Popover visibility
  const id = open ? 'wallet-popover' : undefined; //ID for Popover

  const Help_message_popup = () => {
    setAlert_message('If you have any queries or concerns, please drop an email to romeo7Aug1992@gmai.com');
    setMessage_status('info');
  }

  const Referral_message_popup = () => {
    setAlert_message(`You have a referral code = ${user_referral_code}. Share this referral code to 3 new users and get Rs.300/- credited to your account. If a single new user uses your referral code, then you'll get Rs.100/- credited as referral bonus.`);
    setMessage_status('info');
  }

  // Navigate to Subscription page.
  // const navigate = useNavigate()

  // const subscription_page = () => {
  //     navigate('/subscription')
  // }

  return (
    <div className='Header-container p-2 px-4'>
      <div className="Header-left"><img src={BearMarketLogo} alt="Logo" /></div>
      <div className='Header-center'>
        <h2><span style={{color:"red"}}>Bear</span> <span style={{color:"green"}}>Bull</span> Stocks</h2>
      </div>
      <div className="Header-right">

        <img src={referralIcon} alt='Referral-Icon' className='Header-right-icon' onClick={Referral_message_popup}/>
        {/* <referralIcon onClick = {Referral_message_popup} className='Header-right-icon' alt='Referral-Icon' /> */}
        <HelpIcon className='Header-right-icon' onClick={Help_message_popup} alt='Help'/>
        {/* <ChatIcon className='Header-right-icon' /> */}
        

        {/* <WalletIcon className='Header-right-icon'onClick={UpdateonSubmit}/> */}
        <div>
          {/* Wallet Icon wrapped in IconButton */}
          {/* <IconButton aria-describedby={id} onClick={Wallet_handleClick}> */}
          <WalletIcon aria-describedby={id} onClick={Wallet_handleClick} className="Header-right-icon" />
          {/* </IconButton> */}

          {/* Popover positioned below the WalletIcon */}
          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={Wallet_handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center'
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center'
            }}
          >
            <List>
              <ListItem >
                <ListItemText primary={`Balance: ₹${paid}/-`} />
              </ListItem>
              {/* <div onClick={UpdateonSubmit}> */}
              <ListItem component='div' onClick={UpdateonSubmit}>
                <ListItemText style={{ cursor: 'pointer' }} primary="Pay" />
              </ListItem>
              <ListItem component='div' onClick={get_transaction_statement}>
                <ListItemText style={{ cursor: 'pointer' }} primary="Transactions" />
              </ListItem>

              {/* <ListItem >
                <ListItemText style={{ cursor: 'pointer' }} primary="Subscription Plan" onClick={subscription_page}/>
              </ListItem> */}

              {/* </div> */}
            </List>
          </Popover>
        </div>


        {/* <AccountCircleIcon  className='Header-right-icon' onClick={()=>props.signOut()}/> */}
        <div>
          <AccountCircleIcon aria-describedby={accountId} className='Header-right-icon' onClick={handleAccountClick} />
          <Popover
            id={accountId}
            open={accountOpen}
            anchorEl={accountAnchorEl}
            onClose={handleAccountClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center'
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center'
            }}
          >
            {user !== null ? 
            <List>
              <ListItem >
                <ListItemText  primary={user.signInDetails.loginId} />
              </ListItem>
            </List>
            : '' }
            
            <List>
              <ListItem >
                <ListItemText onClick={Logout} style={{ cursor: 'pointer' }} primary='LogOut' />
              </ListItem>
            </List>
          </Popover>

          <Transactions transaction_alert={transaction_alert} toggle_transaction_alert={toggle_transaction_alert} statements={statement} />
        </div>
      </div>
    </div>
  )
}

export default Header